module.exports = __webpack_public_path__ + "static/media/icon_jingzhunjiance.37bea8ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_jingzhunjiance.svg
// module id = 124
// module chunks = 0